import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { Site } from 'shared/hooks';
import { ShiftPopoverDetail } from 'api/services/shift/schema/shift-detail.schema';

export const useOgpGetShiftPopoverDetail = (site: Site, shiftId: string, enabled?: boolean) => {
  const queryFn = async () => await sharedShiftService.getShiftPopoverDetail(site, shiftId);
  const queryKey = QUERY_KEYS.shiftPlanningShiftPopoverDetail(shiftId);

  return useQuery<Promise<ShiftPopoverDetail>, Error, ShiftPopoverDetail>({
    queryKey,
    queryFn,
    enabled: !!shiftId && enabled !== false,
    staleTime: 1000 * 60 * 5,
  });
};
